import { stage as stageEnum } from '../../../utils';

export const analyticNameToLabelMap = {
  projectedRevenue: {
    value: 'projectedRevenue',
    label: 'Projected Revenue',
  },
  netProfit: {
    value: 'netProfit',
    label: 'Net Profit',
  },
  costOfCapital: {
    value: 'costOfCapital',
    label: 'Cost Of Capital',
  },
  platformFees: {
    value: 'platformFees',
    label: 'Platform Fees',
  },
  inventory: {
    value: 'inventory',
    label: 'Inventory',
  },
};

export function getAnalyticLabel(name: string) {
  if (analyticNameToLabelMap[name]) {
    return analyticNameToLabelMap[name].label;
  }
  if (stageEnum[name]) {
    return stageEnum[name].label;
  }
  return name;
}
